// MA-833 — the runtime viewport meta. App.jsx rewrites index.html's viewport
// meta at mount to lock zoom for a kids' touch app (maximum-scale=1,
// user-scalable=no). The rewrite used to DROP index.html's `viewport-fit=cover`,
// which makes iOS report every env(safe-area-inset-*) as 0 (the offline banner's
// status-bar padding, the session headers' top inset and BottomTabBar's bottom
// inset were all inert in a home-screen install). Keep both intents here.
export const VIEWPORT_CONTENT =
  "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover";

/** Rewrite the document's viewport meta; returns false when there is none. */
export function applyViewportMeta(doc: Pick<Document, "querySelector">): boolean {
  const meta = doc.querySelector('meta[name="viewport"]');
  if (!meta) return false;
  meta.setAttribute("content", VIEWPORT_CONTENT);
  return true;
}
